import { FlagsContextModel } from 'config/useFlagsContext'
import { isCboNivelSuperior } from 'types/NivelCbo'

export const canRegisterCid10 = (cbo2002: string, isSomenteCiap: boolean, flags: FlagsContextModel): boolean => {
  if (flags.PILOTO_ENCAMINHAMENTO_CUIDADO_CID10_ENABLED) {
    return isCboNivelSuperior(cbo2002)
  }
  return !isSomenteCiap
}

export const getIsVinculacaoCuidadoAtiva = (flags: FlagsContextModel, isAtendimentoOdonto: boolean): boolean => {
  const pilotoVinculacaoCuidadoOdontoAtivo =
    flags.PILOTO_VINCULACAO_CUIDADO_ENABLED && flags.PILOTO_VINCULACAO_CUIDADO_ODONTO_ENABLED
  return isAtendimentoOdonto ? pilotoVinculacaoCuidadoOdontoAtivo : flags.PILOTO_VINCULACAO_CUIDADO_ENABLED
}
